require('./bootstrap-setup');
import AOS from 'aos';
import ModuloBox from './plugins/modulobox.js';
import './plugins/gridzy.min.js';
import Flickity from 'flickity';
import axios from 'axios';
import mixitup from 'mixitup';

AOS.init();

// Remove background-img border
document.querySelectorAll('img:not([src])').forEach((element) => {
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
});

// Add and remove class on scroll
if(document.querySelector('nav')) {
    let scrollpos      = window.scrollY
    const header       = document.querySelector("nav")
    const headerHeight = header.offsetHeight

    const addClassOnScroll    = () => header.classList.add("navbar-shrink")
    const removeClassOnScroll = () => header.classList.remove("navbar-shrink")

    window.addEventListener('scroll', function() {
        scrollpos = window.scrollY;

        if(scrollpos >= headerHeight) {
            addClassOnScroll()
        } else {
            removeClassOnScroll()
        }
    });
}

// Smooth scroll
if(document.querySelector('.js-scroll-trigger')) {
    document.querySelectorAll('.js-scroll-trigger').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            const href      = event.currentTarget.getAttribute("href");
            const offsetTop = document.querySelector(href).offsetTop;

            scroll({
                top:      offsetTop,
                behavior: "smooth"
            });
        });
    });
}

// Parallax
if(document.querySelector('#parallax')) {
    const elem     = document.querySelector("#parallax");
    const parallax = (e) => {
        let _w                        = window.innerWidth / 2;
        let _h                        = window.innerHeight / 2;
        let _mouseX                   = e.clientX;
        let _mouseY                   = e.clientY;
        let _depth                    = `${50 - (_mouseX - _w) * 0.01}% ${50 - (_mouseY - _h) * 0.01}%`;
        elem.style.backgroundPosition = `${_depth}`;
    }

    document.addEventListener("mousemove", parallax);
}

// Menu
if(document.querySelector('nav')) {

    const nav    = document.querySelector('.navbar-toggler');
    const navbox = document.querySelector('.nav-mobile-box');
    nav.addEventListener("click", toggleMenu);

    function toggleMenu() {
        nav.classList.toggle('open-menu');
        navbox.classList.toggle('show-mobile-box');
    }

    // close menu when clicking outside of nav
    window.addEventListener('click', function(e) {
        if(!document.querySelector('nav').contains(e.target) && (navbox.classList.contains('show-mobile-box'))) {
            navbox.classList.toggle('show-mobile-box');
            nav.classList.toggle('open-menu');
        }
    })
}

if(document.querySelector('.tile-carousel')) {
    const tileCarousel = new Flickity('.tile-carousel', {
        cellAlign:      'center',
        wrapAround:     true,
        setGallerySize: true,
        groupCells:     false,
        pageDots:       false,
        draggable:      false,
        autoPlay:       3000,
        adaptiveHeight: true
    });

    const tileParent = document.querySelector('.img-tiles');

    tileCarousel.on('change', (index) => {

        switch(index) {
            case 0:
                tileParent.classList.add('order-one');
                tileParent.classList.remove('order-four', 'order-two');
                break;
            case 1:
                tileParent.classList.add('order-two');
                tileParent.classList.remove('order-one', 'order-three');
                break;
            case 2:
                tileParent.classList.add('order-three');
                tileParent.classList.remove('order-two', 'order-four');
                break;
            case 3:
                tileParent.classList.add('order-four');
                tileParent.classList.remove('order-three', 'order-one');
                break;
            default:
                break;
        }
    });

    // Wrap the last word of the title in <span class="text-primary">...</span>
    document.querySelectorAll('.tile-carousel h2.text-dark').forEach((el) => {
        el.innerHTML = el.innerHTML.replace(/(\S+)\s*$/, '<span class="text-primary">$1</span>');
    });
}

// Modulobox
var modulobox = new ModuloBox({
    mediaSelector:      '.gallery figure > a, .hidden-gallery div',
    loop:               3,
    history:            true,
    controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
    shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
    videoMaxWidth:      1440,
    minZoom:            1,
    zoomTo:             1.8,
    mouseWheel:         false,
    contextMenu:        false,
    scrollToZoom:       true,
    captionSmallDevice: false,
    thumbnails:         true,
    thumbnailsNav:      'centered',
    thumbnailSizes:     {
        1920: {
            width:  110,
            height: 80,
            gutter: 10
        },
        1280: {
            width:  90,
            height: 65,
            gutter: 10
        },
        680:  {
            width:  0,
            height: 0,
            gutter: 0
        }
    }
});

modulobox.on('beforeOpen.modulobox', function(gallery, index) {
    if(window.cubeRAF) {
        cancelAnimationFrame(window.cubeRAF);
        window.cubeRAF = false;
    }
});

modulobox.on('afterClose.modulobox', function(gallery, index) {
    if(typeof Event === 'function' && !window.cubeRAF) {
        window.dispatchEvent(new Event('scroll'));
    }
});

modulobox.init();

const submitForm = (gRecaptchaResponse) => {
    const form = document.querySelector('.form');

    const submitButton     = form.querySelector('[type="submit"]');
    const currentInnerHtml = submitButton.innerHTML;
    submitButton.classList.add('disabled');
    submitButton.disabled  = true;
    submitButton.innerHTML = '<p class="d-flex justify-content-end align-items-end"><div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Laden...</span></div></p>';

    const formData = new FormData(form);
    formData.append('g-recaptcha-response', gRecaptchaResponse);

    const validationAlert = document.getElementById('form-validation');
    validationAlert.classList.add('d-none');
    validationAlert.classList.remove('alert-danger');

    document.querySelectorAll('.invalid-feedback').forEach((element) => {
        if(!element.classList.contains('d-none')) {
            element.classList.add('d-none');
        }
    });

    document.querySelectorAll('.is-invalid').forEach((element) => {
        element.classList.remove('is-invalid');
    });

    axios.post(form.action, formData).then((response) => {
        if(response.data.success) {
            validationAlert.innerHTML = response.data.message;
            validationAlert.classList.add('alert-success');
            validationAlert.classList.remove('d-none');

            form.innerHTML = '';
        }
    }).catch((exception) => {
        if(exception.response.data.errors) {
            for(let error in exception.response.data.errors) {
                const el = form.querySelector('[id="' + error + '"]');
                el.classList.add('is-invalid');
                const feedback = el.parentNode.parentNode.querySelector('.d-none') || el.parentNode.querySelector('.d-none');
                if(feedback !== null) {
                    feedback.classList.remove('d-none');
                }
            }
        }
    }).finally(() => {
        submitButton.classList.remove('disabled');
        submitButton.disabled  = false;
        submitButton.innerHTML = currentInnerHtml;
    });
}

window.submitForm = submitForm;

if(document.querySelector('.filter-container')) {
    const mixer = mixitup(document.querySelector('.filter-container'), {
        selectors: {
            target: '.grid-item'
        }
    })
}

if(document.querySelector('.page-body')) {
    document.querySelectorAll('.page-body').forEach((item) => {
        item.querySelectorAll('img').forEach((image) => {
            image.classList.add('img-fluid');

            if(image.style.float === 'right') {
                image.style.marginLeft   = '15px';
                image.style.marginBottom = '15px';
                image.style.marginRight  = '0';
            } else if(image.style.float === 'left') {
                image.style.marginRight  = '15px';
                image.style.marginBottom = '15px';
                image.style.marginLeft   = '0';
            }
        });

        item.querySelectorAll('table').forEach((table) => {
            table.classList.add('table', 'table-striped', 'table-hover', 'table-sm');
            table.border = 0;

            if(!table.parentNode.classList.contains('table-responsive')) {
                let wrapper       = document.createElement('div');
                wrapper.className = 'table-responsive';

                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }

            table.querySelectorAll('tr').forEach((tr) => {
                tr.style.height = 'auto';
            });

            table.querySelectorAll('td').forEach((td) => {
                td.style.height = 'auto';
            });

            table.querySelectorAll('p').forEach((p) => {
                p.style.marginBottom = 0;
            });
        });

        item.querySelectorAll('iframe').forEach((iframe) => {
            if(iframe.src.match(/youtube|youtu/)) {
                if(!iframe.parentNode.classList.contains('ratio')) {
                    let wrapper       = document.createElement('div');
                    wrapper.className = 'ratio ratio-16x9';

                    iframe.parentNode.insertBefore(wrapper, iframe);
                    wrapper.appendChild(iframe);
                }
            }
        });
    });
}